import { apiFetch } from './base';
import type { Me } from '@/domain/types';

/** Получить текущего пользователя из сессии */
export function me(): Promise<Me> {
  // silentError=true: bootstrapAuth сам обрабатывает 401 (me=null, без редиректа)
  return apiFetch<Me>('/api/v1/me', { silentError: true });
}

/** Обменять authCode от TN Life на сессию */
export function lifeAuth(authCode: string): Promise<{ user: Me }> {
  return apiFetch<{ user: Me }>('/auth/life', {
    method: 'POST',
    body: JSON.stringify({ authCode }),
  });
}

/** Разлогиниться */
export function logout(): Promise<void> {
  return apiFetch<void>('/auth/logout', { method: 'POST' });
}
